"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const getPlatformKeyboardType_1 = __importDefault(require("./utils/getPlatformKeyboardType"));
const ControlRendererContext_1 = __importDefault(require("../../../ControlRendererContext"));
const PlacesAutocomplete_1 = __importDefault(require("../PlacesAutocomplete"));
const inputValueApplyTextMask_1 = __importDefault(require("../../../shared/inputValueApplyTextMask"));
const useAppStateUpdateControlById_1 = __importDefault(require("../../../hooks/useAppStateUpdateControlById"));
const useAppAtomStyleFromControlStyle_1 = __importDefault(require("../../../hooks/useAppAtomStyleFromControlStyle"));
const useAppStateSelector_1 = __importDefault(require("../../../hooks/useAppStateSelector"));
const appStateSelectRoutingStackCurrentRouteTransitionSpeed_1 = __importDefault(require("../../../shared/appStateSelectRoutingStackCurrentRouteTransitionSpeed"));
const SubTextInputRenderer = ({ control, blurOnSubmit, onSubmitEditing, onBlur, onFocus, onChangeText, onMaskMatched, onChangeAddress, }) => {
    var _a, _b, _c, _d, _e, _f;
    const { Render, functions: { processor }, } = (0, react_1.useContext)(ControlRendererContext_1.default);
    const refPlacesAutocomplete = (0, react_1.useRef)(null);
    const refTextInput = (0, react_1.useRef)(null);
    const platform = processor.root.platformOS;
    const maxLength = (_a = control.textFieldConfig) === null || _a === void 0 ? void 0 : _a.charMax;
    const secureTextEntry = control['secure-text-entry'] || false;
    const keyboardType = (0, getPlatformKeyboardType_1.default)(control.keyboardType, platform);
    const getAtomStyle = (0, useAppAtomStyleFromControlStyle_1.default)();
    const styleInput = Object.assign(Object.assign({}, getAtomStyle({
        color: (_b = control.style) === null || _b === void 0 ? void 0 : _b.color,
        fontSize: (_c = control.style) === null || _c === void 0 ? void 0 : _c.fontSize,
        textAlign: (_d = control.style) === null || _d === void 0 ? void 0 : _d.textAlign,
    })), { width: '100%', height: '100%' });
    const controlAtomStyle = getAtomStyle((_e = control.style) !== null && _e !== void 0 ? _e : {});
    const editable = !control.disabled;
    const svgIcon = (0, react_1.useMemo)(() => {
        var _a, _b;
        if (!control.iconConfig
            || !control.iconConfig.enabled
            || !styleInput.fontSize
            || !styleInput.color) {
            return null;
        }
        if (typeof control.iconConfig.icon === 'string') {
            return (react_1.default.createElement(Render.View, { style: { marginRight: 10 } },
                react_1.default.createElement(Render.SvgIcon, { name: control.iconConfig.icon, family: "material", size: styleInput.fontSize, color: styleInput.color })));
        }
        if (!((_b = (_a = control.iconConfig) === null || _a === void 0 ? void 0 : _a.icon) === null || _b === void 0 ? void 0 : _b.name)) {
            return null;
        }
        return (react_1.default.createElement(Render.View, { style: { marginRight: 10 } },
            react_1.default.createElement(Render.SvgIcon, { name: control.iconConfig.icon.name, family: control.iconConfig.icon.family, size: styleInput.fontSize, color: styleInput.color })));
    }, [control.iconConfig, styleInput.fontSize, styleInput.color, Render]);
    const updateControlById = (0, useAppStateUpdateControlById_1.default)();
    const transitionSpeed = (0, useAppStateSelector_1.default)(appStateSelectRoutingStackCurrentRouteTransitionSpeed_1.default);
    (0, react_1.useEffect)(() => {
        if (!control.focus) {
            return undefined;
        }
        const textInput = refTextInput.current;
        const placesAutocomplete = refPlacesAutocomplete.current;
        let isCanceled = false;
        setTimeout(() => {
            if (isCanceled) {
                return;
            }
            if (textInput) {
                textInput.focus();
            }
            if (placesAutocomplete) {
                placesAutocomplete.focus();
            }
            updateControlById({
                control,
                dataToUpdate: {
                    focus: false,
                },
            });
        }, transitionSpeed !== null && transitionSpeed !== void 0 ? transitionSpeed : 0);
        return () => {
            isCanceled = true;
        };
    }, [
        updateControlById,
        control,
        transitionSpeed,
    ]);
    if (control.placesAutocomplete) {
        return (react_1.default.createElement(Render.View, { style: Object.assign(Object.assign({}, controlAtomStyle), { height: 'auto' }) },
            svgIcon,
            react_1.default.createElement(PlacesAutocomplete_1.default, { control: control, onBlur: onBlur, onFocus: onFocus, inputRef: refPlacesAutocomplete, onChange: onChangeAddress })));
    }
    return (react_1.default.createElement(Render.View, { style: controlAtomStyle },
        svgIcon,
        react_1.default.createElement(Render.TextInput, { ref: refTextInput, keyboardType: keyboardType, placeholder: control.placeHolder || undefined, multiline: !!control.multiline, maxLength: maxLength, placeholderTextColor: controlAtomStyle.placeHolderColor, value: (_f = control.value) === null || _f === void 0 ? void 0 : _f.toString(), secureTextEntry: secureTextEntry, style: styleInput, returnKeyType: control.keyboardReturnKeyType || undefined, blurOnSubmit: blurOnSubmit, onSubmitEditing: onSubmitEditing, onBlur: onBlur, onFocus: onFocus, editable: editable, onChangeText: (newValue) => {
                var _a;
                const maskedInput = (0, inputValueApplyTextMask_1.default)({
                    inputValue: newValue,
                    mask: (_a = control.inputMask) !== null && _a !== void 0 ? _a : undefined,
                });
                onChangeText(maskedInput);
                if (control.inputMask && maskedInput.length === control.inputMask.length) {
                    onMaskMatched === null || onMaskMatched === void 0 ? void 0 : onMaskMatched(maskedInput);
                }
            } })));
};
exports.default = SubTextInputRenderer;
